
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 1.063l-.75.53L9.187 14.626l-.78.563-.845.624L2.5 19.375h-.031v.031s-.66.469-1.094 1.313c-.434.843-.59 2.234.313 3.5l3.78 5.312c.903 1.266 2.286 1.59 3.22 1.438.933-.153 1.562-.657 1.562-.657h.031l3.313-2.5L14 27.5V24h1v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2V8h2V4.625l-.219-.281-2.156-2.563zm-.344 2.718L29 5.406V6h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-1.531l-2.031-2.531-1-1.282zM8.813 17.344l3.187 4V26.5l-2.906 2.188h-.031a1.992 1.992 0 01-.72.28c-.402.067-.734.134-1.25-.593-1.417-1.996-2.898-4.113-3.75-5.313-.515-.726-.378-1.062-.187-1.437a2.02 2.02 0 01.469-.594L3.656 21zm-2 4.062l-1.625 1.188 3 4 1.624-1.188z"}})])
          )
        }
      }
    